import React, { useEffect, useState } from 'react';
import { getConfiguration, saveConfiguration, clearCacheData } from '../../actions/configurationActions';
import { getForms } from '../../actions/formActions';
import { listStocks, emptyListStocks } from '../../actions/stocksActions';
import { getTag, saveTag } from '../../actions/tagActions';
import { useNavigate } from 'react-router-dom';
import { FaSave, FaWindowClose } from 'react-icons/fa'; // Importing the plus icon
import { useSelector, useDispatch, } from 'react-redux';
import SearchBox from '../Common/SearchBox/SearchBox';
import SearchBoxWithListing from '../Common/SearchBoxWithListing';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { configToStrategy, getUserFromToken, randomString, strategyToConfig } from '../../utils/utility';
import _ from 'lodash'

const AddEditTags = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const searchBoxKey = "company_filter_tag_search_form";
    const listFormKey = "stock_list_form";
    const { userId = 'INVALID' } = getUserFromToken() || {};

    const isEdit = location.pathname.includes('/edit');
    const isAdd = location.pathname.includes('/add');
    const isCopy = location.pathname.includes('/copy');
    const formState = useSelector((state) => state.forms);
    const stockState = useSelector((state) => state.stocks);
    const tagState = useSelector((state) => state.tags);
    const { formJson = {} } = formState;
    const { tag = {}, saveResponse = {} } = tagState;
    const searchBoxJson = formJson[searchBoxKey] || {};
    const { listing = {} } = stockState;
    const [updatedSearchBoxValues, setUpdatedSearchBoxValues] = useState({});
    const [searchPayload, setSearchPayload] = useState({});

    useEffect(() => {
        dispatch(emptyListStocks());

        if (isEdit || isCopy) {
            const urlParams = new URLSearchParams(window.location.search);
            const id = urlParams.get('id'); // Get the value of 'r'
            if (id != null) {
                dispatch(getTag({ id, enabled: true, deleted: false, type: `EQ_TAGS##${userId}` }));
            }
            else {
                toast.error('In-valid ID');
            }
        }
    }, []);

    useEffect(() => {
        if (!_.isEmpty(searchBoxJson) && (isCopy || isAdd || (isEdit && !_.isEmpty(tag)))) {
            setUpdatedSearchBoxValues(getUIData(tag));
            dispatch(getForms(searchBoxKey, listFormKey));
        }
    }, [searchBoxJson, tag])

    useEffect(() => {
        if (!_.isEmpty(saveResponse)) {
            const { status = {} } = saveResponse;
            const { success = false } = status;
            if (success) {
                toast.success('Successfully Saved');
                navigate('/tags') /*window.close()*/
            }
        }
    }, [saveResponse])

    const listApi = (data) => {
        console.log("data", data);
        setSearchPayload(data);
        const { inclusion = {}, exclusion = {} } = data;
        const _payload = { ...inclusion, exclusion };
        return dispatch(listStocks(_payload, listFormKey));
    }

    const getUIData = (payload) => {
        const { id = '', key = '', type = '', data = {} } = payload;
        const { exclusion = {}, description = '', inclusion = {} } = data;

        if (isAdd || isCopy) {
            return {
                generalInformation: { type: `EQ_TAGS##${userId}`, key: randomString(10), description },
                exclusion, inclusion
            }
        }
        return {
            generalInformation: { id, key, type, description },
            exclusion, inclusion
        }
    }

    const getUIToConfig = (payload) => {
        const { generalInformation = {}, inclusion = {}, exclusion = {} } = payload;
        const { description = '', ...restInfo } = generalInformation;
        return {
            ...restInfo,
            data: {
                description, inclusion, exclusion
            }
        }
    }

    const handleSave = () => {
        if (_.isEmpty(searchPayload)) {
            toast.warning('Submit the form at least once before saving');
        } else {
            dispatch(saveTag(getUIToConfig(searchPayload)));
        }

    }

    return (
        <div style={{ position: 'relative', paddingBottom: '80px' }}> {/* Added padding-bottom */}
            <SearchBoxWithListing
                searchBoxKey={searchBoxKey}
                listFormKey={listFormKey}
                fetchForm={getForms}
                listApi={listApi}
                searchBoxJson={searchBoxJson}
                listingData={listing}
                updatedSearchBoxValues={updatedSearchBoxValues}
            // disableFetchingForm={true}
            />
            <div
                onClick={() => handleSave()}
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    backgroundColor: 'green',
                    color: 'white',
                    borderRadius: '50%',
                    padding: '15px',
                    cursor: 'pointer',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                }}
                title={'Save Tag'}
            >
                <FaSave size={20} />
            </div>
            <div
                onClick={() => { navigate('/tags') /*window.close()*/ }}
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '100px',
                    backgroundColor: 'red',
                    color: 'white',
                    borderRadius: '50%',
                    padding: '15px',
                    cursor: 'pointer',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                }}
                title={'Cancel'}
            >
                <FaWindowClose size={20} />
            </div>
        </div >
    );
}

export default AddEditTags;
